export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("sv-SV", {year:'numeric', month:'long', day:'numeric'})
}